// A-ESQUE card image slider: moves the grey bar as the images are swiped.
// Works on cards added later too (filters, sorting, pagination).
if (!customElements.get('card-image-slider')) {
  customElements.define(
    'card-image-slider',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cis-track]');
        this.thumb = this.querySelector('[data-cis-thumb]');
        if (!this.track || !this.thumb) return;

        this.count = this.track.children.length;
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const max = this.track.scrollWidth - this.track.clientWidth;
            const progress = max > 0 ? this.track.scrollLeft / max : 0;
            this.thumb.style.transform = `translateX(${progress * (this.count - 1) * 100}%)`;
          });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }
    }
  );
}
